









































































































import { Component, Vue, Prop, PropSync, Emit } from 'vue-property-decorator'
import { SchoolController, DropDownController } from '@/services/request.service'

@Component
export default class SchoolEditor extends Vue {
  @Prop({ default: false }) private edit!: boolean
  @PropSync('school', {
    type: Object,
    default: () => ({
      name: '',
      shortName: '',
      introduction: '',
      address: '',
      tel: '',
      type: undefined,
      sectionIds: [],
      email: '',
      memberName: '',
      memberEnName: '',
      openSchoolYear: undefined,
    }),
  })
  private schoolEditor!: any
  private sections: any = []
  private schoolYears: any = []
  private get rules(): any {
    return {
      name: [
        { required: true, message: this.$t('schoolMgmt.enterSchoolName'), trigger: 'change' },
        { max: 100, message: this.$t('schoolMgmt.schoolNameLimit'), trigger: 'change' },
      ],
      shortName: [
        { required: true, message: this.$t('schoolMgmt.enterAbbreviation'), trigger: 'change' },
        { max: 50, message: this.$t('schoolMgmt.schoolAbbreviationLimit'), trigger: 'change' },
      ],
      address: [{ max: 500, message: this.$t('schoolMgmt.schoolAddressLimit'), trigger: 'change' }],
      tel: [{ max: 100, message: this.$t('schoolMgmt.schoolContactLimit'), trigger: 'change' }],
      introduction: [
        { max: 500, message: this.$t('schoolMgmt.schoolIntroductionLimit'), trigger: 'change' },
      ],
      type: [{ required: true, message: this.$t('schoolMgmt.selectNature'), trigger: 'change' }],
      sectionIds: [
        { required: true, message: this.$t('schoolMgmt.selectSection'), trigger: 'change' },
      ],
      email: [
        { required: true, message: this.$t('schoolMgmt.enterAdminAccount'), trigger: 'change' },
        { type: 'email', message: this.$t('schoolMgmt.enterCorrectEmail'), trigger: 'change' },
      ],
      memberName: [{ validator: this.validateZhName, trigger: 'change' }],
      memberEnName: [{ validator: this.validateEnName, trigger: 'change' }],
      openSchoolYear: [
        { required: true, message: this.$t('schoolMgmt.selectOpenSchoolYear'), trigger: 'change' },
      ],
    }
  }

  private created(): void {
    this.getSchoolYears()
  }

  private validateZhName(rule, value, callback) {
    if (!value && !this.schoolEditor.memberEnName) {
      callback(new Error(this.$tc('schoolMgmt.emptyName')))
    } else {
      const schoolEditor = this.$refs.schoolEditor as any
      schoolEditor.clearValidate('memberEnName')
      callback()
    }
  }
  private validateEnName(rule, value, callback) {
    if (!value && !this.schoolEditor.memberName) {
      callback(new Error(this.$tc('schoolMgmt.emptyName')))
    } else {
      const schoolEditor = this.$refs.schoolEditor as any
      schoolEditor.clearValidate('memberName')
      callback()
    }
  }

  private getSchoolYears(): void {
    DropDownController.schoolYearBase()
      .then(res => {
        this.schoolYears = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private getSections(): void {
    const type = this.schoolEditor.type
    DropDownController.getSectionBases(type)
      .then(res => {
        this.sections = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private changeType(): void {
    this.$set(this.schoolEditor, 'sectionIds', [])
    this.getSections()
  }
}
